import React from 'react';

const PriceSummary = ({ priceBreakdown, formData, loyaltyStatus }) => {
  if (!priceBreakdown) return null;

  return (
    <div className="p-6 bg-zinc-800/50 border border-zinc-700 rounded-lg space-y-3">
      <h3 className="text-white font-semibold text-lg mb-3">Price Summary</h3>
      
      <div className="space-y-2 text-sm">
        <div className="flex justify-between text-gray-300">
          <span>{formData.service}</span>
          <span>${priceBreakdown.servicePrice}</span>
        </div>
        
        {formData.addons.length > 0 && (
          <div className="flex justify-between text-gray-300">
            <span>Add-ons ({formData.addons.length})</span>
            <span>${priceBreakdown.addonsTotal}</span>
          </div>
        )}
        
        <div className="flex justify-between text-gray-300">
          <span>Travel Fee</span>
          <span>${priceBreakdown.travelFee}</span>
        </div>
        
        <div className="border-t border-zinc-600 pt-2 flex justify-between text-gray-200 font-medium">
          <span>Subtotal</span>
          <span>${priceBreakdown.subtotal}</span>
        </div>
        
        {priceBreakdown.loyaltyDiscount > 0 && (
          <div className="flex justify-between text-amber-400 font-semibold">
            <span>🎁 {loyaltyStatus?.loyalty_tier} Discount ({(loyaltyStatus?.discount_rate * 100).toFixed(0)}%)</span>
            <span>-${priceBreakdown.loyaltyDiscount.toFixed(2)}</span>
          </div>
        )}
        
        {priceBreakdown.referralDiscount > 0 && (
          <div className="flex justify-between text-green-400 font-semibold">
            <span>🎉 First-Time Customer Discount</span>
            <span>-${priceBreakdown.referralDiscount}</span>
          </div>
        )}
        
        <div className="border-t border-zinc-600 pt-3 flex justify-between text-white font-bold text-lg">
          <span>Total</span>
          <span>${priceBreakdown.total.toFixed(2)}</span>
        </div>
      </div>
      
      <p className="text-xs text-gray-400 mt-3">
        * Final price shown. Payment collected after service completion.
      </p>
    </div>
  );
};

export default PriceSummary;
